
import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { sha3_512 } from 'js-sha3';
import Swal from 'sweetalert2';

class resetPasswordApi {
    static doResetpassword(data) {

        let sendBody={
            code: data.code,
            // reset_password_token: data.reset_password_token,
            password:sha3_512(data.password_confirmation)
        }

        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: JSON.stringify(sendBody)
            }
            return fetch(BASE_URL + '/v1/users/password', body).then(response => {
                if(response.ok === true){
                    Swal.fire({
                        title: 'Password updated successfully',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: true,
                        timer: 3000,
                    })
                    setTimeout(function() { 
                        window.location.href = '/';
                    }, 3000);
                }
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default resetPasswordApi;
